import { createReducer, on } from "@ngrx/store";
import { UIState } from './ui.models';
import { hideHeader, showHeader } from "./ui.actions";

export const initialUiState: UIState = {
    showHeader: false
}

export const uiReducer = createReducer(
    initialUiState,
    on(showHeader, state => ({...state, showHeader: true})),
    on(hideHeader, state => ({...state, showHeader: false}))
)